import React, { useEffect, useState } from 'react';
import './deviceLogin.css';
import AIEduButton from '../../../components/Button/AIEduButton';
import AppIcon from '../../../assets/images/AI_Assistant_App_logo.svg';
import microsoftIcon from '../../../assets/images/microsoft_colored_login.svg';
import googleIcon from '../../../assets/images/google_colored_login.svg';
import { API } from '../../../services';
import { useIntl } from 'react-intl';

const DeviceLogin = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const searchParams = new URLSearchParams(window.location.search);
    const macId = searchParams.get('macId');
    const sessionId = searchParams.get('sessionId');
    const deviceName = searchParams.get('deviceName');

    const [termUrl, setTermUrl] = useState(null);
    const [policyUrl, setPolicyUrl] = useState(null);
    const [cookiePolicyUrl, setCookiePolicyUrl] = useState(null);

    useEffect(() => {
        API.getTermsAndPolicy('orgId').then(({ data }) => {
            const { terms } = data;
            setTermUrl(terms?.[0]?.termUrl);
            setPolicyUrl(terms?.[1]?.termUrl);
            setCookiePolicyUrl(terms?.[2]?.termUrl);
        });
    }, []);

    const handleNavigation = (url) => {
        if (!url) return;
        window.open(url, '_blank');
    };

    const LOGIN_URL =
        process.env.REACT_APP_AI_ASSISTANCE_HOST + '/ums/auth/login';

    const handleGoogleSignInBtnClick = async () => {
        const updatedDeviceName = deviceName === 'null' ? '--' : encodeURI(deviceName);
        window.location.replace(
            `${LOGIN_URL}?macId=${macId}&sessionId=${sessionId}&deviceName=${updatedDeviceName}`
        );
    };

    const handleMicrosoftSignInBtnClick = async () => {
        const updatedDeviceName = deviceName === 'null' ? '--' : encodeURI(deviceName);
        window.location.replace(
            `${LOGIN_URL}?idp=microsoft&macId=${macId}&sessionId=${sessionId}&deviceName=${updatedDeviceName}`
        );
    };

    const SignInButtonStyle = ({ text, icon, handleClick, className }) => {
        return (
            <AIEduButton
                className={className}
                severity='secondary'
                label={
                    <div className='flex ml-5'>
                        <div className='account_logo'>
                            <img src={icon} />
                        </div>
                        <div className='flex align-items-center'>{text}</div>
                    </div>
                }
                onClick={handleClick}
                outlined
            />
        );
    };

    return (
        <div className='mobile-page-layout'>
            <div className='device-login'>
                <header className='device-header'>
                    <div className='app_logo'>
                        <img src={AppIcon} />
                    </div>
                    <div>{f({ id: 'AI_EDU_AI_ASSISTANT_ADMIN_PORTAL' })}</div>
                </header>
                <main className='main'>
                    <div className='main-header'>{f({ id: 'AI_EDU_SIGN_IN' })}</div>
                    <div className='login-text'>
                        {f({ id: 'AI_EDU_GET_STARTED_WITH_SAMSUNG_AI_ASSISTANT' })}
                    </div>
                    <div className='signin-options'>
                        <SignInButtonStyle
                            text={f({ id: 'AI_EDU_CONTINUE_WITH_GOOGLE' })}
                            icon={googleIcon}
                            className='btn btnPrimary'
                            handleClick={handleGoogleSignInBtnClick}
                        />
                        <SignInButtonStyle
                            text={f({ id: 'AI_EDU_CONTINUE_WITH_MICROSOFT' })}
                            icon={microsoftIcon}
                            className='btn btnPrimary'
                            handleClick={handleMicrosoftSignInBtnClick}
                        />
                    </div>
                </main>
                <footer className='footer'>
                    <div className='flex justify-content-between'>
                        <div
                            onClick={() => handleNavigation(termUrl)}
                            className='cursor-pointer hover:underline'
                        >
                            {f({ id: 'AI_EDU_TERMS_AND_CONDITION' })}
                        </div>
                        <div
                            onClick={() => handleNavigation(policyUrl)}
                            className='cursor-pointer hover:underline'
                        >
                            {f({ id: 'AI_EDU_PRIVACY_POLICY' })}
                        </div>
                        <div
                            onClick={() => handleNavigation(cookiePolicyUrl)}
                            className='cursor-pointer hover:underline'
                        >
                            {f({ id: 'AI_EDU_COOKIE_POLICY' })}
                        </div>
                    </div>
                    <div>
                        {f({ id: 'AI_EDU_COPYRIGHT_TEXT' })}
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default DeviceLogin;
